<script>
  import Button from '@ui/pico/button.svelte';
  import Form from '@ui/pico/form.svelte';
  import Input from '@ui/pico/input.svelte';
  import Select from '@ui/pico/select.svelte';
  import { afterUpdate, onMount } from 'svelte';
  import { createForm, getSite, getSites } from '../../services';
  import { exitIfEscape, goto } from '../../util';
  import { pages } from '../../config';
  import FeIcon from '../components/fe-icon.svelte';

  export let site;
  export let sites = [];
  export let params;

  let siteInfo;
  $: sid = params.sid;
  $: form = { sid };

  onMount(async () => {
    site = sid;
    if (!sid) {
      sites = await getSites();
    }
    siteInfo = await getSite({ sid });
  });
  afterUpdate(() => {
    if (site && !sid) {
      goto(pages.forms.add.url, site);
    }
  });
  async function saveForm() {
    await createForm(form);
    goto(pages.sites.overview.url, sid);
  }
  function goback() {
    if (!sid) {
      alert('sid is not home!');
    }
    goto(pages.sites.overview.url, sid);
  }
</script>

<svelte:window on:keyup={exitIfEscape(pages.account.list.url)} />

<nav aria-label="breadcrumb">
  <ul>
    <li>
      <a href="{pages.dashboard.url}">
        <i class="ri-home-3-line"></i>
      </a>
    </li>
    {#if siteInfo}
    <li>
      <a href="{pages.sites.overview.url}/{site}">
        {siteInfo?.domain}
      </a>
    </li>
    {/if}
    <li>
      New Form
    </li>
  </ul>
</nav>

<Form on:submit={saveForm}>
  <article>
    <hgroup>
      <h2>Add a Form</h2>
      <h4>Add a form to {siteInfo?.domain || 'to a specified site'}</h4>
    </hgroup>
    {#if site}
      <main>
        {#if false}
          <Select options={sites} />
        {:else}
          <Input bind:value={form.sid} type="hidden" name="sid" label="" />
        {/if}
        <Input name="name" label="Form Name" bind:value={form.name} />
        <Input
          name="formLinkCode"
          label="Form Link Code"
          placeholder="Will be auto-generated if not provided"
          bind:value={form.formLinkCode}
        />
      </main>
      <footer style="margin-top:0;">
        <Button type="clear" class="secondary">Cancel</Button>
        <Button type="submit">Save</Button>
      </footer>
    {:else}
      <Select bind:value={site}>
        <option value={null} />
        {#each sites as s}
          <option value={s._id}>{s.domain}</option>
        {/each}
      </Select>
    {/if}
  </article>
</Form>
